export default __webpack_public_path__ + "static/media/swiper1.51093bb5.png";